import { render, staticRenderFns } from "./ViewRecord.vue?vue&type=template&id=6b6b8e52&scoped=true"
import script from "./ViewRecord.vue?vue&type=script&lang=js"
export * from "./ViewRecord.vue?vue&type=script&lang=js"
import style0 from "./ViewRecord.vue?vue&type=style&index=0&id=6b6b8e52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6b8e52",
  null
  
)

export default component.exports